import Table from "../../../components/stateful/table/Table";
import CustomDialog from "../../../components/stateless/dialog/CustomDialog";
import PrivatePageLayout from "../../../layout/privatePageLayout/PrivatePageLayout";
import FilingForm from "../filings/filingForm/FilingForm";
import { useHistoricalFilingsController } from "./HistoricalFilingsController";

function HistoricalFilings (props: any) {
  const {
    values,
    loading,
    columns,
    filingDialogOpen,
    selectedFiling,
    filingForm,
    filingFormType,
    handleRowSelect,
    toggleFilingDialog,
  } = useHistoricalFilingsController(props);

  const renderHistoricalFilings = () => {
    return (
      <div>
        <Table
          values={values}
          columns={columns}
          tableName={"Historical Filings"}
          height={"83svh"}
          isLoading={loading}
          onRowClick={(e) => {handleRowSelect(e.dataItem)}}
        />
        <CustomDialog
          open={filingDialogOpen}
          title={'Historical Filing'}
          toggleDialog={toggleFilingDialog}
          hideButtons
          size="large"
        >
          <FilingForm
            filing={selectedFiling}
            filingFormType={filingFormType}
            filingFormData={filingForm}
            closeFilingForm={toggleFilingDialog}
            readOnly
          />
        </CustomDialog>
      </div>
    )
  }

  return (
    <PrivatePageLayout>
      {renderHistoricalFilings()}
    </PrivatePageLayout>
  )
}

export default HistoricalFilings;